import { DataEntryStepper } from "src/ui/widgets/stepper/stepper";
import { useDataEntryWrapper } from "./data-entry.wrapper.hook";
import { Button, Loader } from "src/ui/widgets";
import { Documents, ResumePurchaseAccordion } from "src/ui/fragments";
import { DataEntry } from "./manage-data-normal/data-entry";
import { DataEntryGroup } from "./manage-data-group/data-entry-group";

export const DataEntryWrapper = ({step} : {step: number}) => {
  const {
    isDesktop,
    currentStep,
    isGroup,
    insuranceFormik,
    normalValidationSchemas,
    agency,
    continueDisabled,
    postPolicyPending,
    putPolicyPending,
    postQuestionnairePending,
    resumePurchaseAccordionIsVisible,
    t,
    goBack,
  } = useDataEntryWrapper({step});

  const Topbar = (
    <Button
      flavor="transparentAccentBack"
      text={t("commons.back")}
      classes="my-4 p-0"
      classesText="text-uppercase font-14-semibold"
      onPress={goBack}
    />
  );

  const Title = (
    <div className="mt-3 mb-5">
      <DataEntryStepper currentStep={currentStep} />
    </div>
  );

  const Content = (
    <div className="d-flex flex-column min-vh-100 justify-content-center">
      <div className="container">
        {Topbar}

        <div className="pb-5">
          {Title}
          {!isGroup ? (
            <DataEntry
              currentStep={currentStep}
              insuranceFormik={insuranceFormik}
              validationSchema={normalValidationSchemas[currentStep]}
              agency={agency}
            />
          ) : (
            <DataEntryGroup
              currentStep={currentStep}
              insuranceFormik={insuranceFormik}
            />
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div>
      {(postPolicyPending || putPolicyPending || postQuestionnairePending) && (
        <div className="m-auto d-flex justify-content-center mb-3">
          <Loader overlay />
        </div>
      )}
      {resumePurchaseAccordionIsVisible && (
        <div className={!isDesktop ? "resume-purchase-sticky" : undefined}>
          <ResumePurchaseAccordion
            formik={insuranceFormik}
            continueDisabled={continueDisabled}
          />
        </div>
      )}

      <main className="flex-grow-1">{Content}</main>
      <div className="px-3 py-5 p-md-5 bg-white">
        <div className="container">
          <Documents />
        </div>
      </div>
    </div>
  );
};
